
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { MappingFormProps } from "./types";

export const MappingForm = ({ headers, columnMapping, onMappingChange }: MappingFormProps) => {
  const requiredFields = [
    { key: "name", label: "Name" },
    { key: "email", label: "Email" },
    { key: "phone", label: "Phone" },
  ];
  
  const optionalFields = [
    { key: "meta_notes", label: "Notes" },
  ];

  return (
    <div className="mb-6 space-y-4">
      <div className="space-y-2">
        <h3 className="text-base font-medium">Required Fields</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {requiredFields.map((field) => (
            <div key={field.key} className="space-y-1">
              <label className="text-sm font-medium">{field.label}*</label>
              <Select 
                value={columnMapping[field.key] || ""}
                onValueChange={(value) => onMappingChange(field.key, value)}
              >
                <SelectTrigger className="w-full">
                  <SelectValue placeholder={`Select ${field.label} column`} />
                </SelectTrigger>
                <SelectContent>
                  {headers.map((header) => (
                    <SelectItem key={header} value={header}>
                      {header}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          ))}
        </div>
      </div>

      <div className="space-y-2">
        <h3 className="text-base font-medium">Optional Fields</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {optionalFields.map((field) => (
            <div key={field.key} className="space-y-1">
              <label className="text-sm font-medium">{field.label}</label>
              <Select
                value={columnMapping[field.key] || ""}
                onValueChange={(value) => onMappingChange(field.key, value)}
              >
                <SelectTrigger className="w-full">
                  <SelectValue placeholder={`Select ${field.label} column`} />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="none">None</SelectItem>
                  {headers.map((header) => (
                    <SelectItem key={header} value={header}>
                      {header}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
